module.exports = __webpack_public_path__ + "static/media/travel.cbfaae8b.svg";